import {Component, EventEmitter, OnInit, Output, signal} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {environment} from "projects/store/src/environments/environment";
import {toOptionArray, SalesWorkflow} from "projects/store/src/app/enums";
import {UtilService} from "library";
import {CustomMessageService} from "library";
import {PaymentOptions} from "projects/store/src/app/enums/payment-options";

enum AccountType {
  'cuenta-corriente' = 'Cuenta Corriente',
  'cuenta-ahorro' = 'Cuenta Ahorro'
}

@Component({
  selector: 'app-sales-payment-information-kredicash',
  templateUrl: './sales-payment-information-kredicash.component.html',
})
export class SalesPaymentInformationKredicashComponent implements OnInit {
  id: string;
  flowCode: string;
  request: any;
  submitted: boolean = false;
  loading: boolean = false;
  country = environment.global.country;
  lukiStatus = signal<any>({});
  visibleLukiModal: boolean = false;
  visibleBankTransferModal: boolean = false;
  visibleYappyModal: boolean = false;
  visibleLukiBannerModal: boolean = false;
  visibleLukyNewClientModal: boolean = false;
  selectedOption: any;
  optionPayment = PaymentOptions;

  paymentOptions = [
    {name: 'Transferencia a otros bancos', value: this.optionPayment['banking-transfer']}
  ];

  @Output() gotoStepEvent = new EventEmitter();
  @Output() nextStepEvent = new EventEmitter();

  protected readonly AccountType = toOptionArray(AccountType);

  constructor(
    protected route: ActivatedRoute,
    protected utilService: UtilService,
    protected requestService: RequestService,
    protected customMessageService: CustomMessageService
  ) {
    this.id = this.route.snapshot.params['request_id'];
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.request = this.requestService.request;
  }

  get isFlowKrdya(): boolean {
    return this.flowCode === SalesWorkflow['app-krdya-kredicash'];
  }

  ngOnInit(): void {
    // Container: la inicialización se delega a los hijos (V2/V3)
  }

  onContinue() {
    switch (this.selectedOption) {
      case this.optionPayment["luki-client"]:
        this.visibleLukiModal = true;
        break;
      case this.optionPayment["banking-transfer"]:
        this.visibleBankTransferModal = true;
        break;
      case this.optionPayment["luki-new-client"]:
        this.visibleLukyNewClientModal = true;
        break;
      case this.optionPayment.yappy:
        this.visibleYappyModal = true;
        break;
    }
  }

  onGotoStep(navigationData: { flowCode: string; stepCode: string }) {
    this.gotoStepEvent.emit(navigationData);
  }

  onCloseLukyModal(event: boolean) {
    this.visibleLukiModal = event;
  }

  onCloseBankTransferModal(event: boolean) {
    this.visibleBankTransferModal = event;
  }

  onCloseLukiNewClientModal(event: boolean) {
    this.visibleLukyNewClientModal = event;
  }

  onCloseYappyModal(event: boolean) {
    this.visibleYappyModal = event;
  }

  onCloseLukiBannerModal(event: boolean) {
    this.visibleLukiBannerModal = event;
  }

  onSetLukiStatus($event: any) {
    this.lukiStatus.set($event);
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }
}
